import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { LayoutService } from '../layout/layout.service';
import { BrandAllocation } from '../../client-core/dtos/brand-allocation.models';
import { BrandService } from '../../client-core/services/brand.service';
import { ValidationMessage } from 'app/validation';
import { ChangeDriver, ChangeIndicator } from 'app/client-core/dtos/change-driver.model';
import { NewAllocationRequest } from 'app/client-core/dtos/new-allocation-request.model';
import { NewAllocationResponse } from 'app/client-core/dtos/new-allocation-response.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'edit-reason',
  templateUrl: './edit-reason.component.html',
  styleUrls: ['./edit-reason.component.scss']
})
export class EditReasonComponent implements OnInit, OnChanges {
  @Input() brandAllocation: BrandAllocation;
  @Input() brandRetailerAllocationId: number;
  @Input() title: string;

  changeDriverSelected: ChangeDriver = null;
  changeResonId = 0;
  ready: boolean;
  submitted: boolean;
  validationMessages: any;
  changeReasons: Array<{ changeReasonId: number, changeReasonDesc: string, isDefault: number, showChangeReason: number, showChangeDriver: number }> = [];
  changeReasonComment: string;
  saving: boolean;
  showChangeReason: boolean;
  changeDrivers: ChangeDriver[];
  changeIndicators: ChangeIndicator[];
  showChangeDriver: boolean;
  newAllocationRequest: NewAllocationRequest;
  newAllocationResponse: NewAllocationResponse = {
    isShown: false
  } as NewAllocationResponse;
  changeIndicatorSubscription: Subscription;
  loadingIndicators: boolean;
  createIncrementalProgram = 0;
  quarterlyBreakoutIsShown = 0;

  constructor(
    private layoutService: LayoutService,
    private brandService: BrandService
  ) {
  }

  ngOnInit(): void {
    this.layoutService.updateEditReason.subscribe(data => {
      const comment = this.brandAllocation.comment;
      this.brandAllocation = data.brandAllocation;
      this.brandAllocation.comment = comment;
      this.title = data.title;
      this.brandRetailerAllocationId = data.brandRetailerAllocationId;

      this.loadProgram(false);
      // this.loadNewAllocation();
    });
  }

  loadNewAllocation() {
    this.brandService.getNewAllocation().subscribe(response => {
      if (!response.error) {
        this.newAllocationResponse = response[0];
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadProgram();
    // this.loadNewAllocation();
  }

  closeModal() {
    this.createIncrementalProgram = 0;
    this.quarterlyBreakoutIsShown = 0;
    this.getChangeIndicator(0, 1);
    this.brandService.AllocationSaved.next();
    this.layoutService.hideSideModal.next();
  }

  loadProgram(forceReload: boolean = true): void {
    this.ready = false;
    let promisses = [
      this.getChangeIndicator(),
      this.getChangeReason()
    ];

    if ((!this.changeDrivers || this.changeDrivers.length == 0) || forceReload) 
      promisses.push(this.getChangeDriver());

    Promise.all(promisses).then(() => {
      this.ready = true;
    })
  }

  getChangeReason() {
    return new Promise((resolve, reject) => {
      this.brandService.getChangeReasons({
        brandId: this.brandAllocation.brandId,
        budgetYear: this.brandAllocation.budgetYear,
        totalAtl: this.brandAllocation.totalAtl,
        totalBtl: this.brandAllocation.totalBtl
      })
        .subscribe(res => {
          this.ready = true;
          if (!res.hasError) {
            this.changeReasons = res.data.items;
            this.changeResonId = this.changeReasons.find(c => c.isDefault == 1).changeReasonId;
            this.showChangeReason = this.changeReasons.findIndex(c => c.showChangeReason == 1) > -1;
          } else {
            this.validationMessages = new ValidationMessage(res.error, true, "Program could not be retrieved");
          }
          resolve(true);
        },
          (err: any) => {
            this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
            reject();
          },
          () => {
          });
    })
  }

  getChangeDriver() {
    return new Promise((resolve, reject) => {
      this.brandService.getChangeDriver({
        brandId: this.brandAllocation.brandId,
        budgetYear: this.brandAllocation.budgetYear,
        totalAtl: this.brandAllocation.totalAtl,
        totalBtl: this.brandAllocation.totalBtl
      })
        .subscribe(res => {
          this.ready = true;
          if (!res.hasError) {
            this.changeDrivers = res.data;
            this.showChangeDriver = this.changeDrivers.findIndex(c => c.showChangeDriver == 1) > -1;
          } else {
            this.validationMessages = new ValidationMessage(res.error, true, "Program could not be retrieved");
          }
          resolve(true);
        },
          (err: any) => {
            this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
            reject();
          },
          () => {
          });
    })
  }

  getChangeIndicator(submit = 0, cancel=0) {
    this.loadingIndicators = true;
    if (this.changeIndicatorSubscription) {
      this.changeIndicatorSubscription.unsubscribe();
    }
    return new Promise((resolve, reject) => {
      this.changeIndicatorSubscription = this.brandService.getChangeIndicator({
        brandId: this.brandAllocation.brandId,
        totalAtl: this.brandAllocation.totalAtl,
        totalBtl: this.brandAllocation.totalBtl,
        sessionId: this.brandAllocation.sessionId || "",
        submit,
        q1: this.changeIndicators ? this.changeIndicators[0].q1Percent : '',
        q2: this.changeIndicators ? this.changeIndicators[0].q2Percent : '',
        q3: this.changeIndicators ? this.changeIndicators[0].q3Percent : '',
        q4: this.changeIndicators ? this.changeIndicators[0].q4Percent : '',
        cancel,
        createProgram: this.createIncrementalProgram,
        quarterlyBreakoutIsShown: this.quarterlyBreakoutIsShown
      })
        .subscribe(res => {
          this.ready = true;
          if (!res.hasError) {
            this.changeIndicators = res.data;
            this.quarterlyBreakoutIsShown = res.data[0].quarterlyBreakoutIsShown ? 1 : 0;
          } else {
            this.validationMessages = new ValidationMessage(res.error, true, "Program could not be retrieved");
          }
          this.loadingIndicators = false;
          resolve(true);
        },
          (err: any) => {
            this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
            this.loadingIndicators = false;
            reject();
          },
          () => {
          });
    })
  }

  onSubmit(): void {
    this.submitted = false;
    if (!this.canSubmit()) {
      this.validationMessages = new ValidationMessage(null, true, "There are some validation errors.");
      this.submitted = true;
      return;
    }

    this.saving = true;
    this.brandAllocation.changeReasonId = this.changeResonId;
    this.brandService.saveBrandAllocation(
      this.brandAllocation,
      this.brandRetailerAllocationId,
      this.changeDriverSelected,
      this.changeIndicators[0]
    ).subscribe(res => {
      this.getChangeIndicator(1).then(() => {
        this.saving = false;
        if (!res.hasError) {
          this.validationMessages = new ValidationMessage(null, true, "Change saved successfully").isSuccess();
          this.brandService.AllocationSaved.next();
          this.closeModal();
        } else {
          this.validationMessages = new ValidationMessage(res.error, true, "Could not save");
        }
      });
    },
      (err: any) => {
        this.saving = false;
        this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
      },
      () => {
      });
  }

  canSubmit() {
    return this.isChangeDriverValid();
  }

  isChangeDriverValid() {
    if (!this.showChangeDriver) {
      return true;
    }

    if (!this.changeDriverSelected) {
      return false;
    }

    return true;
  }

  isPercentsValid() {
    if (!this.changeIndicators[0].percentEntryEnabled) {
      return true;
    }
    const percentSum = 
      parseFloat(this.changeIndicators[0].q1Percent.toString() || '0') + 
      parseFloat(this.changeIndicators[0].q2Percent.toString() || '0') + 
      parseFloat(this.changeIndicators[0].q3Percent.toString() || '0') + 
      parseFloat(this.changeIndicators[0].q4Percent.toString() || '0')
    return percentSum == 100;
  }

  shouldDisableSubmit() {
    if (this.loadingIndicators) {
      return true;
    }

    if (this.changeIndicators && this.changeIndicators[0].percentEntryEnabled && !this.isPercentsValid()) {
      return true;
    }

    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/edit-reason/edit-reason.component.ts